<template>
	<div class="add-big-class">
		<el-form class="add-big-form" ref="form" :model="form" label-position='right' :rules="addCategoryRules"  :inline-message='true' label-width="140px">
			<el-form-item label="店铺级大类：" prop="className">
				<el-input
					v-model="form.className"
					autocomplete="off"
					size='mini'
					style="width:150px;float:left;"
					placeholder="请输入店铺级大类"
				></el-input>
			</el-form-item>
			<!-- <el-form-item label="店铺首页显示：">
				<div style="text-align:left">
					<el-radio v-model="radio" label="1">是</el-radio>
					<el-radio v-model="radio" label="2">否</el-radio>
				</div>
			</el-form-item>
			<el-form-item label="店铺级大类icon：">
			</el-form-item>
			<span style="color:#F56C6C;position: absolute;top: 100px;left: 5px;">*</span>
			<span v-show='showError' style="color:#F56C6C;position: absolute;left: 185px;top: 140px;">请上传店铺级大类icon</span> -->
		</el-form>
		<!-- <label class="upload-label" for="file">
			<div v-if="previewSrc === ''" class="img-upload el-icon-plus"></div>
			<img v-else :src="previewSrc" alt="" class="img-preview">
		</label>
		<p class="format-text">尺寸1:1(最优82*82),大小1M以内,PNG格式的图片</p>
		<input type="file" ref="file" id="file" accept="image/png" v-show="false" @change="getFile"> -->
		<div slot="footer" class="dialog-footer">
			<el-button size="medium" @click="onCancelClick">取 消</el-button>
			<el-button type="primary" size="medium" @click="onSaveClick">保 存</el-button>
		</div>
	</div>
</template>

<script>
const QURL = 'https://fxscms.oss-cn-beijing.aliyuncs.com'
export default {
	name: 'addBigClass',
	props: {
		visibleFlag: Boolean,
		data: {
			type: Object,
			default: () => {}
		},
		templateId: {
			type: String,
			default: ''
		}
	},
	data () {
		let validateName = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('店铺级大类名称不能为空'))
			} else if (value.length > 20) {
				callback(new Error('店铺级大类名称最多20个字'))
			} else if (!this.chinessReg.test(value)) {
				callback(new Error('请输入中文或英文'))
			} else {
				callback()
			}
		}
		return {
			showError: false,
			chinessReg: /^[\u0391-\uFFE5A-Za-z]+$/,
			form: {
				className: '',
				classIcon: '',
				id: ''
			},
			addCategoryRules: {
				className: [
					{ required: true, validator: validateName }
				],
				classIcon: [
					{ required: true, message: '请上传店铺级大类图片' }
				]
			},
			previewSrc: '',
			files: '',
			radio: '1'
		}
	},
	created () {
		this.randerPreview()
	},
	watch: {
		visibleFlag (val) {
			if (val) {
				this.showError = false
				this.$refs.form.resetFields()
				this.randerPreview()
				if (this.$refs.file) {
					this.$refs.file.value = ''
				}
			}
		}
	},
	methods: {
		randerPreview () {
			if (this.$fxUtils.isEmptyObjSHW(this.data)) {
				this.form.className = ''
				this.form.classIcon = ''
				this.form.id = ''
				this.previewSrc = ''
			} else {
				let timestamp = new Date().getTime()
				let imgurl = `${QURL}${this.data.shopCategoryImgurl}`
				this.form.className = this.data.shopCategoryName
				this.form.classIcon = imgurl
				this.form.id = this.data.bc_id
				if (!imgurl) {
					this.previewSrc = ''
				} else {
					this.previewSrc = `${QURL}${this.data.shopCategoryImgurl}?timestamp=${timestamp}`
				}
			}
		},
		refreshData () {
			this.$emit('refreshData')
		},
		getFile (e) {
			let files = e.target.files[0]
			if (files) {
				this.files = files
			}
			let type = this.files.type
			let size = this.files.size / 1024 / 1024
			let reg = new RegExp(/image\/png/)
			if (!reg.test(type)) {
				this.$message.error('上传图片只支持png格式!')
				return false
			}
			if (size > 1) {
				this.$message.error('上传图片大小不能超过1M!')
				return false
			}
			if (!e || !window.FileReader) {
				return false
			}
			let reader = new FileReader()
			reader.readAsDataURL(this.files)
			reader.onloadend = () => {
				let image = new Image()
				image.src = reader.result
				image.onload = () => {
					let width = image.width
					let height = image.width
					if (width / height !== 1) {
						this.$refs.file.value = ''
						this.$message.error('请上传尺寸1:1,大小1M以内的图片!')
						return false
					}
					this.previewSrc = reader.result
					this.showError = false
					this.form.classIcon = this.previewSrc
				}
			}
		},
		onCancelClick () {
			this.$emit('update:visibleFlag', false)
		},
		onSaveClick () {
			this.$refs.form.validate(valid => {
				valid && this.saveHandle()
			})
		},
		saveHandle () {
			// if (this.files === undefined && this.$fxUtils.isEmptyObjSHW(this.data)) {
			// 	this.showError = true
			// 	return false
			// }
			if (this.$fxUtils.isEmptyObjSHW(this.data)) {
				this.addHandle()
			} else {
				this.upDateHandle()
			}
		},
		addHandle () {
			let param = {
				name: this.form.className,
				type: 0
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/saveShopCategory`,
				data: param
			}).then(res => {
				if (res.result) {
					this.addTips()
					// this.upDateImgHandle(res.data).then(res => {
					// 	this.addTips()
					// })
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		upDateHandle () {
			let param = {
				name: this.form.className,
				id: this.form.id,
				pid: 0,
				type: 0
			}
			this.upDatePost(param).then(res => {
				this.upDateTips()
			})
			// if (this.$refs.file && this.$refs.file.value) {
			// 	let param = {
			// 		id: this.data.id,
			// 		name: this.form.className,
			// 		pId: 0,
			// 		type: 0,
			// 		imgUrl: this.data.shopCategoryImgurl,
			// 		templateId: this.templateId
			// 	}
			// 	this.upDatePost(param).then(res => {
			// 		this.upDateTips()
			// 		// this.upDateImgHandle().then(res => {
			// 		// 	this.upDateTips()
			// 		// })
			// 	})
			// } else {
			// 	let param = {
			// 		name: this.form.className,
			// 		type: 0,
			// 	}
			// 	this.upDatePost(param).then(res => {
			// 		this.upDateTips()
			// 	})
			// }
		},
		upDatePost (param) {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIV}/shop/updateShopCategory`,
					data: param
				}).then(res => {
					if (res.result) {
						resolve(res)
					} else {
						this.$message.error(res.msg)
					}
				})
			})
		},
		upDateImgHandle (shopCategoryId = this.data.id) {
			return new Promise((resolve, reject) => {
				var formData = new FormData()
				formData.append('id', shopCategoryId)
				if (this.$fxUtils.isEmptyObjSHW(this.data)) {
					formData.append('oldUrl', '')
				} else {
					formData.append('oldUrl', this.data.shopCategoryImgurl)
				}
				formData.append('file', this.files)
				this.$store.dispatch('requestFilePost', {
					url: `${this.$fxBaseApi.urlQIV}/shop/shopCategory/saveImg`,
					data: formData
				}).then(res => {
					if (res.result) {
						resolve(res)
					} else {
						this.$message.error(res.msg)
					}
				})
			})
		},
		upDateTips () {
			this.$message({
				message: '大类修改成功!',
				type: 'success'
			})
			this.$emit('update:visibleFlag', false)
			this.refreshData()
		},
		addTips () {
			this.$message({
				message: '大类新增成功!',
				type: 'success'
			})
			this.$emit('update:visibleFlag', false)
			this.refreshData()
		}
	}
}
</script>
<style scoped lang="stylus">
.add-big-class {
	.add-big-form {
		position: relative
	}
	.upload-label {
		text-align:center
	}
	.img-upload,.img-preview {
		width: 178px;
		height: 178px;
		line-height: 178px;
		display: inline-block
	}
	.img-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		text-align: center;
		font-size: 28px;
		color: #8c939d;
		&:hover {
			border-color: var(--fx-primary-color);
		}
	}
	.img-preview {
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}
	.format-text {
		height:50px
		line-height:50px
	}
	.dialog-footer {
		margin-top: 30px
	}
}
</style>
